// extracted by mini-css-extract-plugin
module.exports = {"button":"_0cbaba7d8a--button--tmiJO"};